import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import { Lock } from "lucide-react";

interface MvpLockedPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Optional custom title (default: "MVP locked") */
  title?: string;
  /** Optional custom message (default: "This feature will be ready soon.") */
  message?: string;
}

export function MvpLockedPopup({
  open,
  onOpenChange,
  title = "MVP locked",
  message = "This feature will be ready soon.",
}: MvpLockedPopupProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-muted">
              <Lock className="h-5 w-5 text-muted-foreground" />
            </div>
            <DialogTitle className="text-lg">{title}</DialogTitle>
          </div>
        </DialogHeader>
        <p className="text-muted-foreground text-sm">{message}</p>
        <DialogFooter className="sm:justify-end">
          <Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
